import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from "react-intl";
const MagnetLink = ({ magnet }) => {
    return (_jsxs("div", { className: "note-invoice", children: [_jsx("h4", { children: _jsx(FormattedMessage, { id: 'Gcn9NQ', defaultMessage: 'Magnet Link' }) }), _jsx("a", { href: magnet.raw, rel: "noreferrer", children: magnet.dn ?? magnet.infoHash })] }));
};
export default MagnetLink;
